// src/constants/wigOptions.js
export const WIG_OPTIONS = {
  hairLengths: [
    'Short', '8','9','10','11','12','13','14','15','16','17','18','19','20','21',
    '22','23','24','25','26', '27', '28','29','30','31','32','33','34','35','36','37','38'
  ],
  cutStyles: ['DiNi', 'Stylist'],
  wigTypes: [
    '3/4 Lace Top',
    '3/4 Regular',
    'aidel',
    'Deep Lace',
    'Fall',
    'Handsew',
    'Handsew Lace Top',
    'Kippah Fall Topper LaceTop',
    'Kippah Fall Topper Skin Top',
    'Standard Lace Top',
    'Top of Lace Top',
    'Lace Top High Density',
    'Mini Ribbon',
    'Pony Wig',
    'Pony Wig High Density',
    'Skin Top'
  ],
  baseColors: [
    'Dark w/Highlights',
    'Blonde',
    'Light Brown w/Highlights',
    'Brown w/Highlights',
    'Red w/Highlights',
    'Mixed',
    'Light Brown',
    'Brown',
    'Red',
    'Dark',
    'Dark Brown w/Highlights',
    'Blonde w/Highlights',
    'Dark Brown', 
    '#2A/14',
    '#16/60C',
    '#champagne',
    '#6/20',
    '#1/2/8C',
    '#2/6/500',
    '#2/6/10',
    '#8D/60 - champagne',
    '#1/2/10',
  ],
  aidelColors:[
    '1/2/10- Tehila',
    '2/6/10- Renana', 
    '8D/60c- Emma', 
    '1/2/8c- Roni', 
    '2/6/500- Yael', 
    '2A/14- Eti', 
    '6/20- Chen', 
    '16/60c - Shir', 
    'Natural brown- Rachel', 
    'Natural black- Hila',
  ],
  inventoryTypes: ['Custom', 'Stock', 'Wholesaler', 'Handmade', ''], 
  netSizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'Custom', ''],
  hairTypes: ['Body', 'Straight', 'Wavy', 'Curly'],
  aidelHairTypes: ['Loose Waves', 'Tight Waves','Body', 'Straight', 'Wavy', 'Curly'],
  netTypes: ['Regular Net', 'Deep Net', ''],
  laceTypes: [
    'Deep Lace', 'Folded Lace', 'No Cut', 'No Lace', 
    'Pre Cut', 'Pre Cut Bangs', 'Regular Lace', 'Regular No Lace', ''
  ],
  virtualOptions: ['No Virtual Consult', 'Half Virtual Consult', 'Full Virtual Consult'],
  invStatuses: ['', 'Available', 'Sold', 'Pre-Assembly'],
  warehouseTypes: ['Pomona', 'Lakewood', 'Israel', 'China', 'China Nely', 'China Customer', 'China Barely There Customer', 'China ABC'],
  topSizes: [
    '6"x4" 100%', '6"x3" 100%', '6"x3" 90%', '6"x3" 80%',
    '6"x2" 100%', '6"x2" 90%', '6"x2" 80%', 
    '6"x2.5" 100%', '6"x2.5" 90%', '6"x2.5" 80%', 
    '6"x1.5" 100%', '6"x1.5" 90%', '6"x1.5" 80%', ''
  ]
};

// Returns the color options that apply to a given wig type.
// The "aidel" wig type uses its own dedicated color palette.
export const getColorOptions = (wigType) =>
  wigType === 'aidel' ? WIG_OPTIONS.aidelColors : WIG_OPTIONS.baseColors;

// Returns the hair type options that apply to a given wig type.
// The "aidel" wig type is limited to Loose Waves / Tight Waves.
export const getHairTypeOptions = (wigType) =>
  wigType === 'aidel' ? WIG_OPTIONS.aidelHairTypes : WIG_OPTIONS.hairTypes;

// aidel colors are stored as "<code>- <name>" (e.g. "1/2/10- Tehila").
// On printed worksheets/invoices we only want the human name, not the code.
export const formatColorName = (color) => {
  if (!color || typeof color !== 'string') return color;
  if (WIG_OPTIONS.aidelColors.includes(color)) {
    const parts = color.split('-');
    return parts[parts.length - 1].trim();
  }
  return color;
};

export const DEFAULT_WIG_VALUES = {
  CutByStyle: 'DiNi',
  Base_Color: 'Dark',
  Top_Size: '6"x4" 100%',
  Wig_Type: 'Standard Lace Top',
  Wig_Length: 'Short',
  Net_Size: 'M',
  Hair_Type: 'Straight',
  Net_Type: 'Deep Net',
  Lace_Type: 'No Cut',
  Warehouse: 'Pomona',
  InventoryType: 'Stock',
  InvStatus: 'Available'
};

